// Shared "book a demo" target — the same HubSpot meeting scheduler the sidebar CTA and the
// upsell modals open (Cal.com, myyjän kalenteri; korvasi HubSpot Meetings 9.9.2026). Kept in one place so the URL
// isn't re-declared per component.
export const HUBSPOT_DEMO_URL = 'https://cal.com/shady-el-tokhy-sl58vi/tendera';

/**
 * Demo-calendar URL, tagged with where the click came from so the booking is attributable.
 * `metadata[ch]=appi` is what tendera.fi's Cal.com webhook reads to place the booking in the
 * "appi" channel on the funnel dashboard — it is the one signal that does not depend on utm
 * parameters surviving the booking flow, so it is always sent.
 */
export const bookDemoUrl = (surface) => {
    const sep = HUBSPOT_DEMO_URL.includes('?') ? '&' : '?';
    const medium = surface ? 'pro_lock' : 'upsell';
    const content = surface ? `&utm_content=${encodeURIComponent(surface)}` : '';
    return `${HUBSPOT_DEMO_URL}${sep}utm_source=app&utm_medium=${medium}${content}&metadata[ch]=appi`;
};

/** Opens the demo calendar in a new tab; see bookDemoUrl for the surface tag. */
export const openBookDemo = (surface) => {
    window.open(bookDemoUrl(surface), '_blank', 'noopener,noreferrer');
};
